var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"themed-checkbox",on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }